import { apiPrivateAxios } from "../../axios";
import { IFacilitySettings } from "./types";

export const facilitySettingRequest = {
  getFacilitySettings: (): Promise<IFacilitySettings> =>
    apiPrivateAxios.get("/facilitysetting"),
  updateFacilitySettings: (
    data: IFacilitySettings
  ): Promise<IFacilitySettings> => apiPrivateAxios.put("/facilitysetting", data),
};
